export default __webpack_public_path__ + "static/media/popular.8efe8ed8.svg";